import { useForm } from '@mantine/form';
import { TextInput, PasswordInput, Button, Stack, Paper, Title } from '@mantine/core';
import type { LoginCredentials } from '../../types/auth';
import { useTranslation } from '../../hooks/useTranslation';

interface LoginFormProps {
  onSubmit: (values: LoginCredentials) => void;
  isLoading?: boolean;
}

export function LoginForm({ onSubmit, isLoading }: LoginFormProps) {
  const { t } = useTranslation();
  const form = useForm<LoginCredentials>({
    initialValues: {
      email: '',
      password: '',
    },
    validate: {
      email: (value) => (/^\S+@\S+$/.test(value) ? null : t('auth.invalidEmail')),
      password: (value) => (value.length < 6 ? t('auth.passwordTooShort') : null),
    },
  });

  return (
    <Paper radius="md" p="xl" withBorder>
      <Title order={2} mb="md" ta="center">
        {t('auth.welcomeBack')}
      </Title>

      <form onSubmit={form.onSubmit(onSubmit)}>
        <Stack>
          <TextInput
            required
            label={t('auth.email')}
            placeholder={t('auth.emailPlaceholder')}
            {...form.getInputProps('email')}
          />

          <PasswordInput
            required
            label={t('auth.password')}
            placeholder={t('auth.passwordPlaceholder')}
            {...form.getInputProps('password')}
          />

          <Button type="submit" fullWidth mt="xl" loading={isLoading}>
            {t('auth.signIn')}
          </Button>
        </Stack>
      </form>
    </Paper>
  );
} 